import { api } from './client';
import type { ImportResult } from './items';

export interface SalesLine {
  invoice: string; date: string; customer: string; item: string; hsn: string;
  qty: number; rate: number; taxable: number; gst: number; tax: number; total: number;
  cost: number; profit: number; margin: number; vendor: string; loss: boolean;
}
export interface SalesRegisterResp {
  kpis: { grossSales: number; cogs: number; grossProfit: number; margin: number; gst: number; invoices: number };
  lines: SalesLine[];
  byCustomer: { customer: string; invoices: number; qty: number; taxable: number; gst: number; total: number; cost: number; profit: number; margin: number }[];
  byItem: { item: string; hsn: string; qty: number; taxable: number; cost: number; profit: number; margin: number; vendor: string }[];
  byHsn: { hsn: string; qty: number; taxable: number; gst: string; tax: number; total: number }[];
}

export async function getSalesRegister(q: { from?: string; to?: string; customer?: string; vendor?: string }): Promise<SalesRegisterResp> {
  const r = await api.get<SalesRegisterResp>('/accounts/sales-register', { params: q });
  return r.data;
}

export interface PurchaseLine {
  grn: string; date: string; vendor: string; item: string; itemCode: string; hsn: string;
  qty: number; rate: number; taxable: number; gst: number; inputGst: number; total: number;
}
export interface PurchaseRegisterResp {
  kpis: { grossPurchases: number; inputGst: number; bills: number; suppliers: number };
  lines: PurchaseLine[];
  byVendor: { vendor: string; bills: number; qty: number; taxable: number; inputGst: number; total: number }[];
  byItem: { code: string; item: string; hsn: string; qty: number; value: number; avgRate: number; vendor: string }[];
  byHsn: { hsn: string; qty: number; taxable: number; gst: string; tax: number; total: number }[];
}

export async function getPurchaseRegister(q: { from?: string; to?: string; vendor?: string }): Promise<PurchaseRegisterResp> {
  const r = await api.get<PurchaseRegisterResp>('/accounts/purchase-register', { params: q });
  return r.data;
}

export type OsBucket = 'd0' | 'd1' | 'd2' | 'd3';
export interface OsInvoice { no: string; date: string; bucket: OsBucket; amount: number; age: string }
export interface OsGroup {
  code: string; name: string; terms?: string;
  d0: number; d1: number; d2: number; d3: number; total: number; oldest: string; invoices: OsInvoice[];
}
export interface OsTotals { d0: number; d1: number; d2: number; d3: number; total: number }
export interface CustomerOsResp {
  kpis: { totalOutstanding: number; overdue90: number; overCreditLimit: number; avgDays: number; customers: number };
  groups: OsGroup[];
  totals: OsTotals;
}

export async function getCustomerOs(q: { asOn?: string; from?: string; to?: string }): Promise<CustomerOsResp> {
  const r = await api.get<CustomerOsResp>('/accounts/customer-os', { params: q });
  return r.data;
}

export const customerOsTemplatePath = '/accounts/customer-os/import-template.xlsx';

/** Upload open bills (old books / Tally): same invoice no. updates, amount 0 removes. */
export async function importCustomerOs(file: File): Promise<ImportResult> {
  const fd = new FormData();
  fd.append('file', file);
  const r = await api.post<ImportResult>('/accounts/customer-os/import', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 5 * 60 * 1000,
  });
  return r.data;
}
